import { create } from 'zustand';

import {
  BrandStrategy,
  CustomerPersona as CustomerPersonaType,
} from '../types';

type StrategySection =
  | 'customer-personas'
  | 'value-proposition'
  | 'getting-to-know-you'
  | 'tone-of-voice'
  | 'content-plan';

type TState = {
  brandStrategyId: string | null;
  brandStrategy: BrandStrategy | null;
  selected_section: StrategySection;
  why_start_the_business: string | null;
  unique_industry_perspective: string | null;
  proudest_moment_in_business: string | null;
  purpose: string | null;
  mission: string | null;
  vision: string | null;
  customer_personas: CustomerPersonaType[];
  setBrandStrategyId: (id: string | null) => void;
  setBrandStrategy: (strategy: BrandStrategy | null) => void;
  setSelectedSection: (section: StrategySection) => void;
  setWhyStartTheBusiness: (value: string | null) => void;
  setUniqueIndustryPerspective: (value: string | null) => void;
  setProudestMomentInBusiness: (value: string | null) => void;
  setPurpose: (value: string | null) => void;
  setMission: (value: string | null) => void;
  setVision: (value: string | null) => void;
  setCustomerPersonas: (personas: CustomerPersonaType[]) => void;
  reset: () => void;
};

const initialState = {
  brandStrategyId: null,
  brandStrategy: null,
  selected_section: 'customer-personas' as StrategySection,
  why_start_the_business: null,
  unique_industry_perspective: null,
  proudest_moment_in_business: null,
  purpose: null,
  mission: null,
  vision: null,
  customer_personas: [],
};

export const useBrandStrategyStore = create<TState>((set) => ({
  ...initialState,
  setBrandStrategyId: (id) => set({ brandStrategyId: id }),
  setBrandStrategy: (strategy) => set({ brandStrategy: strategy }),
  setSelectedSection: (section) => set({ selected_section: section }),
  setWhyStartTheBusiness: (value) => set({ why_start_the_business: value }),
  setUniqueIndustryPerspective: (value) =>
    set({ unique_industry_perspective: value }),
  setProudestMomentInBusiness: (value) =>
    set({ proudest_moment_in_business: value }),
  setPurpose: (value) => set({ purpose: value }),
  setMission: (value) => set({ mission: value }),
  setVision: (value) => set({ vision: value }),
  setCustomerPersonas: (personas) => set({ customer_personas: personas }),
  reset: () => set(initialState),
}));
